import React, { useState, useEffect } from "react";
import axios from "axios";
import $ from "jquery";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "bootstrap-datepicker/dist/locales/bootstrap-datepicker.ko.min.js";
import "bootstrap-datepicker/dist/js/bootstrap-datepicker.min.js";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
window.$ = window.jQuery = $;
dayjs.extend(utc);
dayjs.extend(timezone);




export default function ExchangeDayList() {
  const formatDate = (date) => date.toISOString().split("T")[0];
  const today = new Date();
  const [startDate, setStartDate] = useState(formatDate(today));
  const [currencyList, setCurrencyList] = useState([]);
  const [toCurrency, setToCurrency] = useState("ALL");
  const [exchangeRates, setExchangeRates] = useState([]);
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
  const $start = $("#sdate");
  const $end = $("#edate");

  if ($start.length) {
    $start.datepicker({
      format: "yyyy-mm-dd",
       language: "ko",
      autoclose: true,
      todayHighlight: true,
    }).on("changeDate", (e) => {
      setStartDate(dayjs(e.date).format("YYYY-MM-DD"));
    });
  }


  return () => {
    $start.datepicker("destroy");
  };
}, []);

  const getExchangeRates = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/exchange`, {
        params: { tr_date: startDate },
      });

      const raw = res.data.data; // 백엔드에서 data 필드 안에 쿼리스트링이 들어 있음
      const params = new URLSearchParams(raw);
      const result = [];

      for (const [key, value] of params.entries()) {
        if (
          /^[A-Z]{3}$/.test(key) && // 3자리 통화코드
          !isNaN(parseFloat(value.replace(/,/g, "")))
        ) {
          result.push({
            to: key,
            rate: parseFloat(value.replace(/,/g, "")), // 쉼표 제거
          });
        }
      }

      result.sort((a, b) => a.to.localeCompare(b.to));

      setExchangeRates(result);
      setCurrencyList(["ALL", ...result.map((r) => r.to)]);
    } catch (err) {
      console.error("환율 조회 실패:", err);
    }
  };

  useEffect(() => {
    getExchangeRates();
  }, [startDate]);

  const filteredRates =
    toCurrency === "ALL"
      ? exchangeRates
      : exchangeRates.filter((item) => item.to === toCurrency);

  return (
    <div className="nk-content">
      <div className="container-fluid">
        <div className="nk-content-inner">
          <div className="nk-content-body">
            <div className="nk-block nk-block vExchangeDayList" id="opt-x">
              <div className="card card-bordered">
                <div className="card-inner-group">
                  <div className="card-inner p-3">
                    <div className="nk-block nk-block-lg">
                      <form className="mb-0">
                        <div className="row tbSearch">
                          <div className="col-12 col-xl-6">
                            <div className="form-group">
                              <div className="form-control-wrap raw">
                                <div className="input-daterange input-group">
                                  <div className="form-control-wrap">
                                    <div className="form-icon form-icon-left">
                                      <em className="icon ni ni-calendar" />
                                    </div>
                                    <input
                                      className="form-control date-picker"
                                      data-date-format="yyyy-mm-dd"
                                      id="sdate"
                                      type="text"
                                      value={startDate}
                                      onChange={(e) =>
                                        setStartDate(e.target.value)
                                      }
                                    />
                                  </div>

                                  <select
                                    value={toCurrency}
                                    onChange={(e) =>
                                      setToCurrency(e.target.value)
                                    }
                                    className="form-control"
                                  >
                                    {currencyList.map((cur) => (
                                      <option key={cur} value={cur}>
                                        {cur}
                                      </option>
                                    ))}
                                  </select>

                                  <div
                                    className="input-group-addon"
                                    style={{
                                      cursor: "pointer",
                                    }}
                                  >
                                    <i className="fas fa-search" />
                                    <font>검색</font>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-xl-6">
                            <div className="timezone-box">
                              <dl>
                                <dt>검색 일자</dt>
                                <dd>{startDate}</dd>
                              </dl>
                              <dl>
                                <dt>화폐</dt>
                                <dd>KRW</dd>
                              </dl>
                              <dl>
                                <dt>타임존</dt>
                                <dd>UTC +9:00</dd>
                              </dl>
                              <dl>
                                <dt>선택 화폐</dt>
                                <dd>{toCurrency}</dd>
                              </dl>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="card-inner tableBox p-0">
                    <div
                      className="table-wrapper"
                      style={{
                        borderTop: "1px dotted #BBB",
                        paddingTop: "5px 0",
                      }}
                    >
                      <div
                        className="table-responsive"
                        data-pattern="priority-columns"
                      >
                        <div data-pattern="priority-columns">
                          <table
                            cellSpacing="0"
                            className="table table-small-font table-bordered table-striped"
                          >
                            <thead>
                              <tr data-pos-y="0">
                                <th
                                  className="text-center"
                                  data-pos-x="0"
                                  data-priority="1"
                                  id="idde0cde25224ea-col-0"
                                >
                                  id
                                </th>
                                <th
                                  className="text-center"
                                  data-pos-x="1"
                                  data-priority="1"
                                  id="idde0cde25224ea-col-1"
                                >
                                  기준 화폐
                                </th>
                                <th
                                  className="text-center"
                                  data-pos-x="2"
                                  data-priority="1"
                                  id="idde0cde25224ea-col-2"
                                >
                                  변환 화폐
                                </th>
                                <th
                                  className="text-center"
                                  data-pos-x="3"
                                  data-priority="1"
                                  id="idde0cde25224ea-col-3"
                                >
                                  금액
                                </th>
                                <th
                                  className="text-center"
                                  data-pos-x="4"
                                  data-priority="1"
                                  id="idde0cde25224ea-col-4"
                                >
                                  기준일
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredRates.map((item, index) => (
                                <tr key={index} data-pos-y="0">
                                  <td
                                    className="text-center"
                                    colSpan="1"
                                    data-pos-x="0"
                                  >
                                    {index + 1}
                                  </td>
                                  <td
                                    className="text-center"
                                    colSpan="1"
                                    data-pos-x="1"
                                  >
                                    KRW
                                  </td>
                                  <td
                                    className="text-center"
                                    colSpan="1"
                                    data-pos-x="2"
                                  >
                                    {item.to}
                                  </td>
                                  <td
                                    className="text-end"
                                    colSpan="1"
                                    data-pos-x="3"
                                  >
                                    {item.rate ?? "조회 실패"}
                                  </td>
                                  <td
                                    className="text-center"
                                    colSpan="1"
                                    data-pos-x="4"
                                  >
                                    <span style={{ fontSize: "85%" }}>
                                      {dayjs(startDate).format("YYYY-MM-DD")}
                                    </span>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
